import { ImprovedHtml } from 'app/views/common-components/ImprovedHtml'
import { parseFormLabelText } from '../../common/Common'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

export const FormHtmlPdf = ({
  typeProps,
  langVersion,
  describeMap,
  objectsFieldsMap
}) => {
  const { html, pdfFontSize } = typeProps

  const parsed = parseFormLabelText({
    text: html,
    langVersion,
    describeMap,
    objectsFieldsMap,
    returnString: true
  })

  const style = { fontSize: pdfDefaultFontSize }
  if (pdfFontSize) {
    style.fontSize = Number(pdfFontSize)
  }

  return (
    <ImprovedHtml style={style}>
      {parsed}
    </ImprovedHtml>
  )
}
